import React from 'react'
import HeroImg from '../../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../../components/Constant/button/Button";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'Offshore Company Formation',
        link: '/offshore-company-formation',
    },
]

function CyprusCompanyFormation() {
    return (
        <main className='main'>
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>Cyprus Company Formation</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>Incorporate in a Leading EU Financial & Business Hub</h3>
                            <p className='page-paragraph'>
                                A <b>Cyprus company</b> offers investors and entrepreneurs the benefits of <b> EU membership, tax advantages, and international credibility.</b>
                                <br/>
                                Popular with <b> forex brokers, holding structures, shipping firms, funds, and professional service companies, </b>Cyprus provides a flexible, well-regulated corporate base.
                            </p>
                            <PageList
                                items={[
                                    {
                                        title: "EU Access",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "12.5% Corporate Tax",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Forex & Holding Hub",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Banking",
                                        icon: TiTick,
                                    },
                                ]}
                            />

                            <Button
                                text="Request a Cyprus Company Formation Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />

                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>
                            Why Incorporate in Cyprus?
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "EU Jurisdiction",
                                    paragraph: "Full access to European markets",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Efficiency",
                                    paragraph: "12.5% corporate tax, one of the lowest in the EU",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Holding Company Hub",
                                    paragraph: "Tax treaties with 65+ countries",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking & Finance",
                                    paragraph: "Respected for forex, funds, and fintech",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Lifestyle & Residency",
                                    paragraph: "Company owners may qualify for residency",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Types of Companies in Cyprus</h3>
                        <PageList
                            items={[
                                {
                                    title: "Private Limited Company (LTD)",
                                    paragraph: "Most common type. For general trading, consulting, forex, and holding structures.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Public Limited Company (PLC)",
                                    paragraph: "For large enterprises or listings.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Branch Office / Subsidiary",
                                    paragraph: "For foreign companies expanding into Cyprus.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Specialized Companies",
                                    paragraph: "Used for forex licenses, fund management, EMI/PSPs, and shipping companies.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Incorporation Requirements
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Shareholders",
                                    paragraph: "Minimum 1 (individual or corporate)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Directors",
                                    paragraph: "Minimum 1 (local recommended for tax residency)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Company Secretary",
                                    paragraph: "Required (local)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Registered Office",
                                    paragraph: "Must be located in Cyprus",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Capital Requirement",
                                    paragraph: "EUR 1,000+ (flexible)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Filing",
                                    paragraph: "Audited accounts filed yearly",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Benefits of a Cyprus Company
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "EU Passport for Business",
                                    paragraph: "Credibility with regulators & banks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Treaties",
                                    paragraph: "Double-tax agreements with 65+ countries",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Access to Banking",
                                    paragraph: "Easier than most offshore jurisdictions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Sector Strengths",
                                    paragraph: "Forex, funds, shipping, holding companies",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Residency Link",
                                    paragraph:
                                        "Owners can apply for Cyprus residency & investment programs",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Incorporation Process
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Pre-Incorporation Consultation",
                                    paragraph: "Define structure & purpose",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Name Reservation",
                                    paragraph: "With the Registrar of Companies",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Document Drafting",
                                    paragraph: "Memorandum & Articles of Association",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Company Registration",
                                    paragraph: "Filing and approval",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax & VAT Registration",
                                    paragraph: "If applicable",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Bank Account Opening",
                                    paragraph: "Local or international bank",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Timeline & Costs
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "2–3 weeks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Cost",
                                    paragraph: "From EUR 5,000+",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Costs",
                                    paragraph: "Accounting, audit, registered office, compliance",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Common Uses of Cyprus Companies
                        </h3>
                        <PageList
                            items={[
                                {
                                    paragraph: "Forex & Brokerage Entity (for CySEC licensing)",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Holding Company (EU & treaty network benefits)",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Fund/Asset Manager (EU-aligned structures)",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Shipping Company (Cyprus is a global maritime hub)",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Consulting & Professional Services",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Why Offshore Advisory?
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Specialists in Cyprus company incorporation & licensing",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "End-to-end support",
                                    paragraph: "Corporate, tax, banking, and licensing",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Connections with lawyers, auditors, and CySEC compliance officers",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative insights",
                                    paragraph: "Cyprus vs Malta vs Isle of Man vs UAE",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Assistance with residency & investment permits",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                    </div>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <CTA
                        title="Looking for a European business hub with low tax?"
                        description="A Cyprus company provides EU recognition, tax efficiency, and access to forex, funds, and shipping opportunities."
                        buttonText="Book a Cyprus Company Formation Consultation →"
                        buttonLink="/consultation"
                    />

                </div>

            </section>
        </main>
    )
}

export default CyprusCompanyFormation

const faqData = [
    {
        question: "What is the tax rate in Cyprus?",
        content: [
            { type: "answer", text: "12.5% — one of the lowest in the EU." },
        ],
    },
    {
        question: "How long does it take to incorporate?",
        content: [
            { type: "answer", text: "2–3 weeks." },
        ],
    },
    {
        question: "Is a local director required?",
        content: [
            { type: "answer", text: "Not legally, but recommended for tax residency." },
        ],
    },
    {
        question: "Do Cyprus companies need audits?",
        content: [
            { type: "answer", text: "Yes — annual audited accounts are mandatory." },
        ],
    },
    {
        question: "Can foreigners own 100%?",
        content: [
            { type: "answer", text: "Yes — there are no restrictions." },
        ],
    },
];

const testimonialsData = [
    {
        quote:
            "We set up a Cyprus company to hold our brokerage license. Offshore Advisory managed the incorporation and audit setup.”",
        author: "Andreas K.",
        role: "Broker CEO",
    },
    {
        quote:
            "Cyprus gave our fintech EU credibility. Offshore Advisory provided full tax and compliance support.",
        author: "Sophia M.",
        role: "FinTech Founder",
    },
];